import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_54zek68l8m: FaireBrandEntity = {
  token: "b_54zek68l8m",
  type: "brand",
  name: "Nuvula",
  avatarUrl:
    "https://cdn.faire.com/fastly/c91a957636372ec84189ddedafb4fb66e0f747710276a80af25835a79e0b7d8a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2e5287b003f23034128059919f0199f6ed8fbd8bbdba98f163310624e0ec260d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c91a957636372ec84189ddedafb4fb66e0f747710276a80af25835a79e0b7d8a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2e5287b003f23034128059919f0199f6ed8fbd8bbdba98f163310624e0ec260d.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 21,
  isInsider: true,
  description:
    "Nuvula is an art driven fashion label that brings original illustration into clothing. Designed and produced in Downtown Los Angeles, the brand combines expressive print, vintage inspired silhouettes, and responsible production.\n\nEach collection begins with hand drawn artwork developed in the studio before it becomes textile. Historical motifs, botanical forms, and geometric compositions are reinterpreted through a contemporary lens, creating garments that feel both timeless and visually bold.\n\nNuvula has presented collections at Fashion Weeks in New York, Los Angeles, Berlin, and London. The brand has been featured in outlets including HBO, E! Entertainment, and Vogue Latin America, and its designs have been worn by artists such as Rihanna, Zendaya, and Jada Pinkett Smith.\n\nAll pieces are developed in the Los Angeles workshop using an environmentally mindful production approach. The brand focuses on efficient manufacturing, textile reuse, and reactive printing techniques that allow artwork to translate vividly onto fabric while minimizing waste.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:40.258Z",
    importedBy: "entity-db-cli",
  },
};
